import { useQuery, useMutation, useQueryClient } from 'react-query';
import { apiClient } from '../services/apiClient';
import { DiagnosisCustomerReadDTO, DiagnosisCustomerCreateDTO } from '../generated/api-client';

export const useDiagnosisCustomer = () => {
  return useQuery<DiagnosisCustomerReadDTO[]>('diagnosisCustomer', () => apiClient.list_items_diagnosis_customer__get());
};

export const useDiagnosisCustomerById = (id: string) => {
  return useQuery<DiagnosisCustomerReadDTO>(
    ['diagnosisCustomer', id],
    () => apiClient.get_item_diagnosis_customer__item_id__get(id),
    {
      enabled: !!id,
    }
  );
};

export const useCreateDiagnosisCustomer = () => {
  const queryClient = useQueryClient();

  return useMutation<DiagnosisCustomerReadDTO, Error, DiagnosisCustomerCreateDTO>(
    (data) => apiClient.create_item_diagnosis_customer__post(data),
    {
      onSuccess: () => {
        queryClient.invalidateQueries('diagnosisCustomer');
      },
    }
  );
};

export const useUpdateDiagnosisCustomer = () => {
  const queryClient = useQueryClient();

  return useMutation<DiagnosisCustomerReadDTO, Error, { id: string; data: DiagnosisCustomerCreateDTO }>(
    ({ id, data }) => apiClient.update_item_diagnosis_customer__item_id__put(id, data),
    {
      onSuccess: () => {
        queryClient.invalidateQueries('diagnosisCustomer');
      },
    }
  );
};

export const useDeleteDiagnosisCustomer = () => {
  const queryClient = useQueryClient();

  return useMutation<any, Error, string>(
    (id) => apiClient.delete_item_diagnosis_customer__item_id__delete(id),
    {
      onSuccess: () => {
        queryClient.invalidateQueries('diagnosisCustomer');
      },
    }
  );
};

